import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/Button'

/** Friendly failure state. Tone: state the problem, offer a retry, get out of the way. */
export function ErrorState({
  title = 'Something went wrong',
  description = "We couldn't load this just now. Please try again.",
  onRetry,
}: {
  title?: string
  description?: string
  onRetry?: () => void
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center" role="alert">
      <AlertTriangle className="h-8 w-8 text-[color:var(--color-danger)]" aria-hidden strokeWidth={1.5} />
      <h2 className="text-h3 text-text-primary">{title}</h2>
      <p className="text-body max-w-md text-text-secondary">{description}</p>
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry} className="mt-2">
          Try again
        </Button>
      ) : null}
    </div>
  )
}
